import { resolveMediaUrl } from '../../lib/mediaUrl';
import type { User } from '../../types';

export function PortalUserChip({ user }: { user: User }) {
  const initial = (user.fullName || user.email || '?').slice(0, 1).toUpperCase();
  const src = resolveMediaUrl(user.avatarUrl);
  return (
    <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-full bg-glass-2 border border-glass">
      {src ? (
        <img src={src} alt="" className="w-7 h-7 rounded-full object-cover" />
      ) : (
        <div
          className="w-7 h-7 rounded-full flex items-center justify-center text-[0.7rem] font-bold text-white"
          style={{
            background:
              'linear-gradient(135deg, rgb(var(--accent-rgb) / 0.85), rgb(var(--accent2-rgb) / 0.65))',
          }}
        >
          {initial}
        </div>
      )}
      <span className="text-sm font-medium text-glass-text max-w-[140px] truncate">
        {user.fullName || user.email}
      </span>
    </div>
  );
}
